module.exports = __webpack_public_path__ + "media/images/athletes/4149-9a5ca2f1db749ec10c38ac205d1c244e.png";